import { useEffect } from "react";

export function usePopulateRides({
  items,
  typeOfProperty,
  typeOfTemplate,
  templates,
  setColumns,
  location,
  setRideItems,
  columns,
  addSetItemsCount,
}) {
  useEffect(() => {
    if (!items) return;

    let newColumns;
    let newRideItems = [];
    let scooters = {};
    let bicycles = {};
    if (typeOfProperty && typeOfTemplate && items) {
      const isOldTemplate = !typeOfProperty.split("|")[1];

      const propertyKey = isOldTemplate ? typeOfProperty + "|us" : typeOfProperty;

      newColumns = templates[propertyKey][typeOfTemplate];
      const ride = templates[propertyKey].ride[typeOfTemplate];
      scooters = { type: "scooter", items: [] };
      bicycles = { type: "bicycle", items: [] };

      ride?.forEach((rideItem) => {
        if (!rideItem) {
          return;
        }
        if (rideItem.id === "Bicycle") {
          bicycles.items.push(rideItem);
          if (scooters.items.length === 3) {
            newRideItems.push(bicycles);
            bicycles = { type: "bicycle", items: [] };
          }
        }
        if (rideItem.id === "Scooter") {
          scooters.items.push(rideItem);
          if (scooters.items.length === 4) {
            newRideItems.push(scooters);
            scooters = { type: "scooter", items: [] };
          }
        }
      });
      if (bicycles.items.length > 0) {
        newRideItems.push(bicycles);
      }
      if (scooters.items.length > 0) {
        newRideItems.push(bicycles);
      }
      setColumns(newColumns);
      setRideItems(newRideItems);
    } else {
      newColumns = columns;
      newRideItems = [{ type: "scooter", items: [] }];
    }

    if (newColumns) {
      addSetItemsCount({ ride: newRideItems, newColumns });
    }
    // Intentionally only re-populates when the template selection triggers change.
    // Including templates/columns/addSetItemsCount (recreated each render) would
    // re-run and overwrite user edits to columns/rides, changing behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, typeOfProperty, typeOfTemplate]);
}
